/* eslint-disable @typescript-eslint/ban-types */

export enum FieldType {
    Carousel = 'carousel',
    Range = 'range',
    MultiSelect = 'multiselect',
    SingleSelect = 'singleselect',
    NumberInput = 'numberinput',
}

interface Option {
    answerText: string;
    value: number | string;
}

interface QuestionBase {
    questionKey: string;
    questionText: string;
    optional: boolean;
    type?: FieldType;
    calloutText?: string | null;
    responseType: Option[];
    displayCrisisWarning: boolean;
    subQuestions?: Question[];
}

export interface MultiSelectQuestion extends QuestionBase {
    keyword: string;
}

export interface SingleSelectQuestion extends QuestionBase {}

export enum FlowType {
    INITIAL_ONBOARDING = 'INITIAL_ONBOARDING',
    LEGACY_PROGRAM = 'LEGACY_PROGRAM',
    MEMBER_WEB_SETTINGS = 'MEMBER_WEB_SETTINGS',
    PRE_SESSION = 'PRE_SESSION',
}

export type Question = MultiSelectQuestion | SingleSelectQuestion;

export type Answer = string | number | string[] | null; //null is value for skipped value

export type MappedAnswers = Record<string, Answer>;

export interface Assessment {
    id: string;
    name: string;
    headerText?: string | null;
    assessmentQuestions: Question[];
}

export type MappedScores = Record<string, number | undefined>;

export interface AssessmentsState {
    assessments: Record<string, Assessment | undefined>;
    scores: MappedScores;
    mostRecentAssessmentDate: string;
}
